import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { CategoryGroup, Job, JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

const jobAttributeValuesAdapter = createEntityAdapter<JSONApiDataObject<CategoryGroup>>({
  selectId: item => item.id
});

export const jobAttributeValuesSlice = createSlice({
  name: 'jobAttributeValues',
  initialState: jobAttributeValuesAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<Job>>),
  reducers: {
    jobAttributeValuesAdded: (state, action) => {
      jobAttributeValuesAdapter.setMany(state, action.payload);
    }
  }
});

export const jobAttributeValuesSelectors = jobAttributeValuesAdapter.getSelectors((state: RootState) => state.jobAttributeValues);
